import { Injectable } from '@angular/core';

@Injectable()
export class ModalInjectorService {
  inputData: any;
  onConfirm: any;
}
